import Vue from 'vue'
import Vuex from 'vuex'
import api from '@/api'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: null,
    equipment: null,
    placesRequested: [],
    totemUsage: null,
    usage: {
      usageId: ''
    },
    authorization: {
      app: null,
      user: null
    },
    credential: {
      app: null,
      user: null
    },
    disableVirtualKeyboard: false,
  },
  mutations: {
    setUser (state, user) {
      state.user = user
    },
    setEquipment (state, equipment) {
      state.equipment = equipment
    },
    setPlacesRequested (state, places) {
      state.placesRequested = places
    },
    setTotemUsage (state, usage) {
      state.totemUsage = usage
    },
    setAuthorizationUser (state, token) {
      state.authorization.user = token
    },
    setAuthorizationApp (state, token) {
      state.authorization.app = token
    },
    setCredentialUser (state, credential) {
      state.credential.user = credential
    },
    setCredentialApp (state, credential) {
      state.credential.app = credential
    },
    setDisableVirtualKeyboard (state, status) {
      state.disableVirtualKeyboard = status
    }
  },
  actions: {
    setUser (context, action) {
      context.commit('setUser', action)
    },
    requestPlacesRequested (context) {
      api.appRequest({
        url: `unit/${context.getters.getUnit.id}/places?requested=1&equipments=1`
      })
      .then(r => {
        context.commit('setPlacesRequested', r.unit.places)
      })
      .catch(e => {
        console.log('requestPlacesRequested error', e)
      })
    },
    createTotemUsage (context) {
      let equipment = context.getters.getEquipment
      api.userRequest({
        url: `place/${equipment.place.id}/booking/only_check_uses`,
        method: 'post',
        data: { equipment_id: equipment.id }
      }).then(r => {
        context.commit('setTotemUsage', r.place.booking)
      }).catch(e => {
        console.log('Erro ao criar utilização para o totem!', e)
      })
    },
    requestUserInfo (context) {
      api.userRequest({
        url: `user/me/info`
      }).then(r => {
        context.commit('setUser', r.user)
      }).catch(e => {
        console.log('Erro ao obter informações do usuário!', e)
      })
    }
  },
  getters: {
    getUser: state => state.user,
    getEquipment: state => state.equipment,
    getUnit: state => state.equipment ? state.equipment.place.unit : null,
    getPlacesRequested: state => state.placesRequested,
    getTotemUsage: state => state.totemUsage,
    getCredentialUser: state => state.credential.user,
    getCredentialApp: state => state.credential.app,
    getTheme: state => {
      if (state.equipment 
          && state.equipment.place 
          && state.equipment.place.unit
          && state.equipment.place.unit.id 
          && state.equipment.place.unit.id == 9)
      {
          return 'theme-engenhao'
      } else {
          return 'theme-default'
      }
    },
    getDisableVirtualKeyboard: state => state.disableVirtualKeyboard,
  }
})
